import CoreNoMatchStartPlaying from
	'../../../../../../core/views/Onboarding/steps/NoMatchStartPlaying';
import { redirectTo } from '../../../../utils';
import template from './index.jst';

class NoMatchStartPlayingView extends CoreNoMatchStartPlaying {
	get template() {
		return template;
	}

	get team_name_key() {
		return 'tipping_team_name';
	}

	get sponsor_key() {
		return 'tipping_sponsor';
	}

	completionRedirect() {
		redirectTo('my-tips');
	}
}

export default NoMatchStartPlayingView;